import React from 'react';
import LoginPage from './pages/Login/LoginPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import HomePage from './pages/Home/HomePage';
import { useFetchUser } from './hooks/useFetchUser';
import SchedulingPage from './pages/Scheduling/SchedulingPage';
import FinalizePage from './pages/Finalize/FinalizePage';
import ContractsPage from './pages/Contracts/ContractsPage';
import FinancialHoldGate from './components/FinancialHoldGate';

const App: React.FC = () => {
  useFetchUser();

  return (
    <div id="App">
      <Router>
        <Routes>
          <Route path="/login" Component={LoginPage} />
          <Route
            path="/scheduling"
            element={
              <FinancialHoldGate>
                <SchedulingPage />
              </FinancialHoldGate>
            }
          />
          <Route
            path="/"
            element={
              <AuthGuard>
                <FinancialHoldGate>
                  <HomePage />
                </FinancialHoldGate>
              </AuthGuard>
            }
          />
          <Route
            path="/finalize/:currentlySchedulingId?/:paymentIntentId?"
            element={
              <AuthGuard>
                <FinancialHoldGate>
                  <FinalizePage />
                </FinancialHoldGate>
              </AuthGuard>
            }
          />
          <Route
            path="/contracts"
            element={
              <AuthGuard>
                <ContractsPage />
              </AuthGuard>
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
